import {
    CREATE_CUTTING_DC_DETAILS_FAILURE_DK,
    CREATE_CUTTING_DC_DETAILS_REQUEST_DK,
    CREATE_CUTTING_DC_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_CUTTING_DC_DETAILS_DK,
    DELETE_CUTTING_DC_DETAILS_FAILURE_DK,
    DELETE_CUTTING_DC_DETAILS_REQUEST_DK,
    DELETE_CUTTING_DC_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_CUTTING_DC_DETAILS_FAILURE_DK,
    FETCH_SINGLE_CUTTING_DC_DETAILS_REQUEST_DK,
    FETCH_SINGLE_CUTTING_DC_DETAILS_SUCCESS_DK,
    FETCH_CUTTING_DC_DETAILS_FAILURE_DK,
    FETCH_CUTTING_DC_DETAILS_REQUEST_DK,
    FETCH_CUTTING_DC_DETAILS_SUCCESS_DK,
    CUTTING_DC_DETAILS_USERFORM_RESET_DK,
    UPDATE_CUTTING_DC_DETAILS_FAILURE_DK,
    UPDATE_CUTTING_DC_DETAILS_REQUEST_DK,
    UPDATE_CUTTING_DC_DETAILS_SUCCESS_DK,
    FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE_DK,
    FETCH_CUTTING_DC_PREVIOUS_LIST_REQUEST_DK,
    FETCH_CUTTING_DC_PREVIOUS_LIST_SUCCESS_DK,
    FETCH_CUTTING_DC_PREVIOUS_LIST_FAILURE_DK,
    FETCH_CUTTING_DC_DETAILS_DC_NO_REQUEST_DK,
    FETCH_CUTTING_DC_DETAILS_DC_NO_SUCCESS_DK,
    FETCH_CUTTING_DC_DETAILS_DC_NO_FAILURE_DK,
    FETCH_GRN_NO_BY_CUTTING_DC_NO_REQUEST_DK,
    FETCH_GRN_NO_BY_CUTTING_DC_NO_SUCCESS_DK,
    FETCH_GRN_NO_BY_CUTTING_DC_NO_FAILURE_DK,
    FETCH_CUTTING_DC_PROGRAM_REQUEST_DK,
    FETCH_CUTTING_DC_PROGRAM_SUCCESS_DK,
    FETCH_CUTTING_DC_PROGRAM_FAILURE_DK,
    FETCH_CUTTING_DC_DETAIL_STYLE_REQUEST_DK,
    FETCH_CUTTING_DC_DETAIL_STYLE_SUCCESS_DK,
    FETCH_CUTTING_DC_DETAIL_STYLE_FAILURE_DK,
    FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_REQUEST_DK,
    FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_SUCCESS_DK,
    FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_FAILURE_DK,
    CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST_DK,
    CREATE_CUTTING_DC_DETAILS_SKU_STYLE_SUCCESS_DK,
    CREATE_CUTTING_DC_DETAILS_SKU_STYLE_FAILURE_DK,
    CUTTING_DC_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET_DK,
    CUTTING_DC_DETAILS_GENERATE_GRID_FINAL_DATA_SET_DK,
    CREATE_CUTTING_DC_DETAILS_GRID_REQUEST_DK,
    CREATE_CUTTING_DC_DETAILS_GRID_SUCCESS_DK,
    CREATE_CUTTING_DC_DETAILS_GRID_FAILURE_DK,
    RESET_CUTTING_DC_DETAIL_GENERATE_SKU_DK,
    FETCH_CUTTING_DC_DETAILS_FORM_REQUEST_DK,
    FETCH_CUTTING_DC_DETAILS_FORM_SUCCESS_DK,
    FETCH_CUTTING_DC_DETAILS_FORM_FAILURE_DK,
    CREATE_STICHING_DETAIL_FORM,
    CREATE_PRINTING_DC_DETAILS_SKU_STYLE_REQUEST_DK,
    CREATE_STICHING_DC_DETAILS_SKU_STYLE_REQUEST_DK,
    CREATE_STICHING_DC_DETAILS_SKU_STYLE_FAILURE_DK,
    CREATE_PRINTING_DC_DETAILS_SKU_STYLE_FAILURE_DK,
    CREATE_PRINTING_DETAIL_FORM,
    CUTTING_DC_DETAILS_EDIT_FABRIC_DK_REQUEST,
    CUTTING_DC_DETAILS_EDIT_FABRIC_DK_FAILURE,
    CUTTING_DC_DETAILS_DELETE_FABRIC_DK_FAILURE,
    CUTTING_DC_DETAILS_DELETE_FABRIC_DK_REQUEST,
    CUTTING_DC_DETAILS_EDIT_FABRIC_DK_SUCCESS,
    RESET_FABRIC_EDIT_FORM,
    CUTTING_DC_DETAILS_DELETE_DK_FAILURE,
    CUTTING_DC_DETAILS_DELETE_DK_REQUEST,
    RESET_CUTTING_ID
} from './cuttingDCDetails.actionsType';

export const CUTTING_DC_DETAILS_DK = 'cuttingDcDetailsDK';

let initialState = {
    loading: false,
    cuttingDCDetailsById: [],
    cuttingDCDetailsForm: [],
    cuttingDCDetails: [],
    cuttingDCDetailsDcNo: [],
    previousList: [],
    grnNoByCuttingDcNo: [],
    cuttingDCProgram: [],
    output: [],
    finalData: [],
    cuttingDCDetailStyle: [],
    generateSKUStyleCuttingDCDetails: [],
    userform: {
        fldFKRatePerPCs: 0,
        // fldFKSKUDetail: [],
        fldQuantity: 0,
        fldFKNoofRolls: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldFKSKUDetail: []
    },
    selectedCuttingDCDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    stichingForm: {},
    cuttingId: '',
    printingForm: {},
    fabricEditData: {}
};

export let cuttingDCDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CUTTING_DC_DETAILS_REQUEST_DK:
        case FETCH_CUTTING_DC_DETAILS_FORM_REQUEST_DK:
        case FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_REQUEST_DK:
        case FETCH_CUTTING_DC_PROGRAM_REQUEST_DK:
        case FETCH_CUTTING_DC_DETAIL_STYLE_REQUEST_DK:
        case FETCH_GRN_NO_BY_CUTTING_DC_NO_REQUEST_DK:
        case FETCH_CUTTING_DC_DETAILS_DC_NO_REQUEST_DK:
        case FETCH_CUTTING_DC_PREVIOUS_LIST_REQUEST_DK:
        case FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_CUTTING_DC_DETAILS_REQUEST_DK:
        case CREATE_CUTTING_DC_DETAILS_GRID_REQUEST_DK:
        case CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST_DK:
        case FETCH_SINGLE_CUTTING_DC_DETAILS_REQUEST_DK:
        case UPDATE_CUTTING_DC_DETAILS_REQUEST_DK:
        case DELETE_CUTTING_DC_DETAILS_REQUEST_DK:
        case CREATE_PRINTING_DC_DETAILS_SKU_STYLE_REQUEST_DK:
        case CREATE_STICHING_DC_DETAILS_SKU_STYLE_REQUEST_DK:
        case CUTTING_DC_DETAILS_EDIT_FABRIC_DK_REQUEST:
        case CUTTING_DC_DETAILS_DELETE_FABRIC_DK_REQUEST:
        case CUTTING_DC_DETAILS_DELETE_DK_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CUTTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingDCDetails: updatePayload
            };
        case FETCH_CUTTING_DC_DETAILS_FORM_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsForm: updatePayload
            };
        case CUTTING_DC_DETAILS_EDIT_FABRIC_DK_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricEditData: updatePayload
            };

        case RESET_FABRIC_EDIT_FORM:
            return {
                ...state,
                loading: false,
                fabricEditData: {}
            };

        case FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generateSKUStyleCuttingDCDetails: updatePayload
            };
        case FETCH_CUTTING_DC_PROGRAM_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingDCProgram: updatePayload?.Program
            };
        case FETCH_CUTTING_DC_DETAIL_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingDCDetailStyle: updatePayload?.CUD
            };
        case FETCH_GRN_NO_BY_CUTTING_DC_NO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                grnNoByCuttingDcNo: updatePayload?.Inward
            };
        case FETCH_CUTTING_DC_DETAILS_DC_NO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsDcNo: updatePayload?.CUD
            };
        case FETCH_CUTTING_DC_PREVIOUS_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsById: updatePayload
            };
        case CREATE_CUTTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                generateSKUStyleCuttingDCDetails: []
            };
        case CREATE_CUTTING_DC_DETAILS_SKU_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingId: updatePayload
            };
        case CREATE_CUTTING_DC_DETAILS_GRID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generateSKUStyleCuttingDCDetails: []
            };
        case FETCH_SINGLE_CUTTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedCuttingDCDetails: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_CUTTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedCuttingDCDetails: {},
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                }
            };
        case DELETE_CUTTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                selectedCuttingDCDetails: {}
            };

        case FETCH_CUTTING_DC_DETAILS_FAILURE_DK:
        case FETCH_CUTTING_DC_DETAILS_FORM_FAILURE_DK:
        case FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_FAILURE_DK:
        case FETCH_CUTTING_DC_PROGRAM_FAILURE_DK:
        case FETCH_CUTTING_DC_DETAIL_STYLE_FAILURE_DK:
        case FETCH_GRN_NO_BY_CUTTING_DC_NO_FAILURE_DK:
        case FETCH_CUTTING_DC_DETAILS_DC_NO_FAILURE_DK:
        case FETCH_CUTTING_DC_PREVIOUS_LIST_FAILURE_DK:
        case FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE_DK:
        case FETCH_SINGLE_CUTTING_DC_DETAILS_FAILURE_DK:
        case CREATE_CUTTING_DC_DETAILS_FAILURE_DK:
        case CREATE_CUTTING_DC_DETAILS_GRID_FAILURE_DK:
        case CREATE_CUTTING_DC_DETAILS_SKU_STYLE_FAILURE_DK:
        case UPDATE_CUTTING_DC_DETAILS_FAILURE_DK:
        case DELETE_CUTTING_DC_DETAILS_FAILURE_DK:
        case CREATE_STICHING_DC_DETAILS_SKU_STYLE_FAILURE_DK:
        case CREATE_PRINTING_DC_DETAILS_SKU_STYLE_FAILURE_DK:
        case CUTTING_DC_DETAILS_EDIT_FABRIC_DK_FAILURE:
        case CUTTING_DC_DETAILS_DELETE_FABRIC_DK_FAILURE:
        case CUTTING_DC_DETAILS_DELETE_DK_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_CUTTING_DC_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_STICHING_DETAIL_FORM: {
            return {
                ...state,
                loading: false,
                stichingForm: {
                    ...state.stichingForm,
                    [payload.key]: payload.value
                }
            };
        }
        case CREATE_PRINTING_DETAIL_FORM: {
            return {
                ...state,
                loading: false,
                printingForm: {
                    ...state.printingForm,
                    [payload.key]: payload.value
                }
            };
        }

        case CUTTING_DC_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET_DK:
            return {
                ...state,
                loading: false,
                output: payload
            };
        case CUTTING_DC_DETAILS_GENERATE_GRID_FINAL_DATA_SET_DK:
            return {
                ...state,
                loading: false,
                finalData: payload
            };
        case RESET_CUTTING_DC_DETAIL_GENERATE_SKU_DK:
            return {
                ...state,
                loading: false,
                generateSKUStyleCuttingDCDetails: []
            };

        case RESET_CUTTING_ID:
            return {
                ...state,
                loading: false,
                cuttingId: ''

            }
        case CUTTING_DC_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                selectedCuttingDCDetails: {}
            };
        default:
            return state;
    }
};
